export default __webpack_public_path__ + "static/media/cardinfo.d5b95a44.webp";